import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services'
import { checkTranslation, translate } from '../../utils/useful'
import { nanoid } from 'nanoid'


export default class HubMainToolbar extends Component {

    state = {

    }

    componentDidMount() {
        // console.log("componentDidMount !!!!!", this.props)
    }

    // componentDidUpdate = (prevProps) => {
    //     if (prevProps.data != this.props.data) {
    //         console.log('updated', this.props)
    //     }
    // }

    render() {
        return (
            <div className='w-100 flexc '>
                <button onClick={() => this.props.changePage('default')} className={"mrd-3 br-5 px-3 py-1 " + (this.props.currentPage._id == 'default' && (this.props.colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg'))} style={{}}>
                    <p className={" font-size-14 " + (this.props.currentPage._id == 'default' ? 'white' : 'white')} style={{color: this.props.colors ? this.props.colors.textColor : 'white'}}>{translate('Applets')}</p>
                </button>
                {this.props.pages.map((item, index) => {
                    return (
                        <button onClick={() => this.props.changePage(item)} key={index} className={" mrd-1 br-5 px-2 py-1 " + (this.props.currentPage._id == item._id && (this.props.colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg'))} style={{}}>
                            <div className="flexcb">
                                <p className={" font-size-14 " + (this.props.currentPage._id == item._id ? 'white' : 'white')} style={{ whiteSpace: 'nowrap', color: this.props.colors ? this.props.colors.textColor : 'white' }}>{checkTranslation(item.name)}</p>
                                {/* {this.props.currentPage._id == item._id &&
                                    <button className="mld-3" onClick={() => { this.goToPage(item) }}>
                                        <img src="/assets/icons/edit-white.svg" width={15} className="flexcc" />
                                    </button>
                                } */}
                            </div>
                        </button>
                    )
                })}
            </div>
        )
    }
}
